import { t } from "@/i18n-js/instance";
import { UserImageWithFallback } from "@/react/components/shared/uikit/UserImageWithFallback";
import { Typography } from "@circle-react-uikit/Typography";
import type { RecordType } from "../../types";

export interface CommunityMemberRecordProps {
  onClick?: (record: RecordType) => void;
  record: RecordType;
}

export const CommunityMemberRecord = ({
  record,
  onClick,
}: CommunityMemberRecordProps) => {
  const { name, avatar_url: avatarUrl } = record;

  const handleClick = () => {
    onClick?.(record);
  };

  return (
    <button
      type="button"
      className="group flex w-full cursor-pointer items-center gap-3 p-2 text-left"
      onClick={handleClick}
    >
      <div>
        <UserImageWithFallback name={name} src={avatarUrl} size="8" />
      </div>
      <div className="min-w-[6rem] grow">
        <Typography.LabelSm>{name}</Typography.LabelSm>
      </div>
      <div className="text-darkest invisible group-hover:visible">
        <Typography.LabelSm>{t("remove")}</Typography.LabelSm>
      </div>
    </button>
  );
};
